import React, { useEffect } from 'react';
import './App.css';
import Router from "./ui/Router";
import { useNavigate } from "react-router-dom";
import {queries} from "./Infrastructure/const/queries";

function App() {
    const navigate = useNavigate();

    useEffect(() => {
        const registerAndSubscribe = async () => {
            try {
                if (!('serviceWorker' in navigator)) {
                    console.error('Service Worker не поддерживается');
                    return;
                }

                // 1️⃣ Проверяем подписку на сервере
                const res = await fetch(`${queries.baseURL}push/check-subscription`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem("userToken")}`
                    }
                });
                const data = await res.json();

                if (data.subscribed) {
                    console.log('Пользователь уже подписан на сервере');
                    return; // подписка есть, выходим
                }

                // 2️⃣ Регистрируем Service Worker
                const registration = await navigator.serviceWorker.register('/service-worker.js');
                console.log('Service Worker зарегистрирован', registration);

                const swReady = await navigator.serviceWorker.ready;

                // 3️⃣ Проверяем локальную подписку в браузере
                const existingSubscription = await swReady.pushManager.getSubscription();
                if (existingSubscription) {
                    console.log('Подписка уже есть локально, отправляем на сервер');
                    await fetch(`${queries.baseURL}push/subscribe`, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${localStorage.getItem("userToken")}`
                        },
                        body: JSON.stringify(existingSubscription),
                    });
                    return;
                }

                // 4️⃣ Создаём новую подписку
                const subscription = await swReady.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(
                        'BNBgQnXv8kIuUQ4SItGp8WNZOfATTSjAxeATePlaQnO7091CFK0Vh6tNiWbe-uPPJJ4pwteSAFMguSoAUk59RpY'
                    ),
                });

                // 5️⃣ Отправляем подписку на сервер
                await fetch(`${queries.baseURL}push/subscribe`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem("userToken")}`
                    },
                    body: JSON.stringify(subscription),
                });

                console.log('Подписка успешно создана и отправлена на сервер', subscription);

            } catch (err) {
                console.error('Ошибка при регистрации или подписке', err);
            }
        };

        registerAndSubscribe();
    }, []);


    return (
        <div className={'bg-[#dae2f3] h-screen relative overflow-hidden'}>
            <Router />
            <button
                className="absolute bottom-5 right-5 bg-[#4573c4]
          text-white px-5 py-1 rounded-md shadow-md text-sm hover:bg-[#365da3]"
                onClick={() => navigate('/help')}
            >
                Допомога
            </button>
        </div>
    );
}

export default App;

function urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

